import request from '../axios/axios';
const BASE_URL = "/system/version";


export const logList = (params) => request({
    url: `${BASE_URL}/androidVersionList`,
    params: params,
    method: 'get'
});

